import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'preact/compat';
import Wrapper from './styles/wrapper';
import Button from './styles/button';
function Unit(props) {
    const { unitPrice, units, description, subDescription, } = props;
    const minValue = 1;
    const maxValue = 10;
    const [value, setValue] = useState(units ?? 1);
    const decrease = () => {
        const newValue = value - 1;
        if (newValue < minValue) {
            return setValue(minValue);
        }
        return setValue(newValue);
    };
    const increase = () => {
        const newValue = value + 1;
        if (newValue > maxValue) {
            return setValue(maxValue);
        }
        return setValue(newValue);
    };
    return (_jsxs(Wrapper.Wrapper, { children: [_jsxs("div", { children: [_jsx(Wrapper.Heading, { children: description }), subDescription && _jsx(Wrapper.SubHeading, { children: subDescription })] }), _jsxs(Wrapper.Unit, { children: [_jsxs(Button.Element, { type: "button", onClick: decrease, children: [_jsx(Button.Label, { children: "Decrease" }), _jsx(Button.Minus, { fill: "var(--primary-medium)" })] }), _jsxs(Wrapper.Price, { children: [_jsx(Wrapper.Heading, { children: value }), _jsxs(Wrapper.SubHeading, { children: ["\u00A3", (Math.round((unitPrice * value) * 100) / 100).toFixed(2)] })] }), _jsxs(Button.Element, { type: "button", onClick: increase, children: [_jsx(Button.Label, { children: "Increase" }), _jsx(Button.Plus, { fill: "var(--primary-medium)" })] })] })] }));
}
export default Unit;
